module.exports = __webpack_public_path__ + "static/media/agricolas.3de8e1b9.pdf";